import { useSelector } from 'react-redux'
import getText from './i18n/labels'
import { TRUSTPILOT_DATA } from '../../config/Constants'

export default function Footer() {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  return (
    <footer id="footer" className="footer">
      <div className="footer-bar"></div>
      <div className="footer-content d-flex justify-content-between">
        <div className="d-flex justify-content-start col-4">
          <a
            rel="noopener noreferrer"
            className="nav-item nav-link me-3 px-2 ms-3 btn-teamviewer"
            href="https://lnx.starinfostudio.it/wp-content/files_mf/Assistenza-TVQS.exe">
            <img src="/img/TeamViewer_logo.svg" alt="TeamViewer" />
          </a>
          <a
            rel="noopener noreferrer"
            className="nav-item nav-link px-2 btn-supremo"
            href="https://lnx.starinfostudio.it/downloads/exe/SupremoP.exe">
            <img src="/img/logo-supremo.svg" alt="Supremo" />
          </a>
        </div>
        <div className="col-4 d-flex align-items-center justify-content-center">
          <div
            className="d-flex align-items-center btn-trustpilot"
            data-locale="it-IT"
            data-template-id={TRUSTPILOT_DATA.templateId}
            data-businessunit-id={TRUSTPILOT_DATA.businessunitId}>
            <a
              className="star-trustpilot-link"
              href={TRUSTPILOT_DATA.url}
              target="_blank"
              rel="noopener">
              <span>{labels.LEAVE_REVIEW_TEXT}</span>
              <span>
                <img src={TRUSTPILOT_DATA.img} alt="Trustpilot" />
              </span>
            </a>
          </div>
        </div>
        <div className="col-4 d-flex align-items-center justify-content-end">
          <a
            rel="noopener noreferrer"
            className="nav-item nav-link font-weight-bold text-primary px-2 py-1 me-3 border-primary footer-button"
            target={'_blank'}
            href="https://www.starsoluzioni.it/dati-societari/">
            {labels.COMPANY_DATA}
          </a>
          <a
            rel="noopener noreferrer"
            className="nav-item nav-link font-weight-bold text-primary px-2 py-1 me-3 border-primary footer-button"
            target={'_blank'}
            href="https://www.starsoluzioni.it/privacy/">
            Privacy & Cookie Policy
          </a>
        </div>
      </div>
    </footer>
  )
}
